import React, { useState, useMemo } from 'react';
import { useTheme } from './useTheme';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b' };
const font = "'DM Sans', sans-serif";

const TIPS_ALL = [
  "Thinker & Doer es una comunidad. Atrévete a preguntar en el chat cómo le hacen otros en sus negocios.",
  "¿Ya conociste a los otros proyectos? Ve a La Sala y lee sus historias. Puedes aprender mucho de ellos.",
  "Si eres Momentum o Growth, ayuda a un Doer en el chat. Tú ya pasaste por ahí.",
  "Comparte un consejo en el chat. Lo que para ti es obvio, para alguien más puede ser exactamente lo que necesita.",
  "No estás solo en esto. Toda la comunidad está construyendo algo, igual que tú.",
  "Si te sientes abrumado, sal a caminar 15 minutos a solas. Las mejores ideas llegan en silencio.",
  "Respira. Tu negocio no se construye en un día. Cada paso cuenta.",
  "Hoy no tienes que hacer todo. Solo haz una cosa bien.",
  "Descansa. Un emprendedor cansado toma malas decisiones.",
  "Lee las noticias de hoy en La Sala. Pueden darte ideas para tu negocio.",
  "Busca en redes a alguien de tu giro que admires. Observa qué hace. Inspírate.",
  "Ve las redes de negocios de OTRO giro diferente al tuyo. Las mejores ideas vienen de afuera.",
  "Lee un libro de negocios este mes. Genio te puede recomendar uno si le preguntas.",
  "Escucha un podcast de emprendimiento mientras trabajas. Aprenderás sin darte cuenta.",
  "¿Ya registraste tus ventas de hoy? No dejes pasar ni un día.",
  "Publica algo en redes hoy. No tiene que ser perfecto, solo tiene que ser real.",
  "Escríbele a un cliente que no te ha comprado en un mes. Un hola puede generar una venta.",
  "Actualiza tus métricas de redes. Saber tus números es poder.",
  "Escribe tu historia en Human Stories. Lo que tú sientes, alguien más lo necesita leer.",
  "¿Tienes una duda? Pregúntale a Genio & Luca. Están disponibles 24/7 para ti.",
  "Genio dice: sal de la caja hoy. Haz algo diferente en tu negocio.",
  "Luca dice: primero lo primero. ¿Ya terminaste tus pendientes de hoy?",
];

const TIPS_SPARK = [
  "No dudes en preguntarle a los Momentum en el chat. Ellos ya pasaron por donde tú estás.",
  "Si tienes miedo, es normal. Todos empezamos así. Lo importante es que estás aquí.",
  "Completa tu actividad de la semana. Cada paso te acerca más a tu primera venta.",
  "Tu idea no tiene que ser perfecta. Solo tiene que empezar.",
];

const TIPS_MOMENTUM = [
  "Un Doer puede necesitar tu consejo. Asómate al chat y echa la mano.",
  "Tú ya sabes vender. Ahora toca ordenar para poder crecer.",
  "¿Tu negocio funciona sin ti un día? Si no, esta semana trabaja en eso.",
];

const TIPS_ONSITE = [
  "Revisa tus entregables. Tu equipo de T&D está trabajando para ti.",
  "Eres parte del programa premium. Aprovecha cada herramienta al máximo.",
];

function getTipPool(membership) {
  const pool = [...TIPS_ALL];
  if (membership === 'spark_seeker' || membership === 'doer') pool.push(...TIPS_SPARK);
  if (membership === 'momentum_builder' || membership === 'growth_mastermind') pool.push(...TIPS_MOMENTUM);
  if (membership === 'onsite_mexico') pool.push(...TIPS_ONSITE, ...TIPS_MOMENTUM);
  return pool;
}

function pickTip(membership) {
  const pool = getTipPool(membership);
  const key = 'td_last_tip';
  const lastIdx = parseInt(localStorage.getItem(key) || '-1', 10);
  let idx;
  do { idx = Math.floor(Math.random() * pool.length); } while (idx === lastIdx && pool.length > 1);
  localStorage.setItem(key, String(idx));
  return pool[idx];
}

export default function TipBanner({ membership, style: extraStyle }) {
  const t = useTheme();
  const tip = useMemo(() => pickTip(membership), [membership]);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div style={{
      background: `linear-gradient(135deg, ${C.turquesa}10, ${C.mango}08)`,
      border: `0.5px solid ${C.turquesa}25`,
      borderRadius: 14,
      padding: '10px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      marginBottom: '1rem',
      ...extraStyle,
    }}>
      <span style={{ fontSize: 18, flexShrink: 0 }}>💡</span>
      <p style={{ fontSize: 13, margin: 0, color: t.text, flex: 1, lineHeight: 1.5, fontFamily: font }}>{tip}</p>
      <button onClick={() => setDismissed(true)} style={{ background: 'none', border: 'none', color: t.textSecondary, fontSize: 16, cursor: 'pointer', padding: '0 2px', flexShrink: 0, opacity: 0.5 }}>×</button>
    </div>
  );
}
